<template>
    <Modal
        v-bind="$attrs"
        v-on="$listeners"
        :value="value"
        class-name="modal-container"
        :width="width"
        @input="onInput"
    >
        <p slot="header" class="header-class">
            <Icon type="ios-alert" color="#FFAE12" size="24" />
            <span class="title">提示</span>
        </p>
        <div class="body-class">
            <p class="text" v-html="text" :style="contentStyle"></p>
        </div>
        <div slot="footer" style="text-align: center; padding: 15px 0px">
            <Button
                class="btn"
                :loading="loading"
                @click="cancel"
                :style="{ background: btnColor }"
                >{{ btnCancel }}</Button
            >
            <Button
                class="btn btn-confirm"
                :loading="loading"
                @click="comfirm"
                :style="{ background: btnColor }"
                >{{ btnConfirm }}</Button
            >
        </div>
    </Modal>
</template>

<script>
export default {
    name: 'Confirm',
    data() {
        return {
            loading: false,
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        // 提示的内容
        text: {
            type: String,
            default: '提示的内容',
        },
        // 确认按钮文字
        btnConfirm: {
            type: String,
            default: '确定',
        },
        // 取消按钮文字
        btnCancel: {
            type: String,
            default: '取消',
        },
        // 确认按钮颜色
        btnColor: {
            type: String,
            default: '',
        },
        // 值
        id: {
            type: String,
            default: '',
        },
        // 宽度
        width: {
            type: String,
            default: '420px',
        },
        // 内容样式
        contentStyle: {
            type: [Object, String],
            default: () => ({}),
        },
    },
    methods: {
        onInput(val) {
            this.$emit('input', val)
        },
        // 取消
        cancel() {
            this.$emit('closeModal', this.id)
        },
        // 确定
        comfirm() {
            this.$emit('confirmModal', this.id)
        },
    },
}
</script>

<style lang="less" scoped>
.header-class {
    text-align: center;
    font-size: 18px;
    border: none;
    height: 60px;
    line-height: 90px;
    .title {
        margin-left: 10px;
        font-size: 18px;
        font-weight: 400;
        color: rgb(170, 170, 170);
    }
}
.body-class {
    text-align: center;
    .text {
        font-size: 18px;
        font-weight: 400;
        text-align: left;
        color: rgb(51, 51, 51);
        text-align: center;
    }
}
.btn {
    width: 135px;
    height: 32px;
    &-confirm {
        background-color: @primary-color;
        color: #ffffff;
    }
}
</style>
<style lang="less">
// 居中
.modal-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 240px;
    .ivu-modal {
        top: 0;
    }
    // 去除边框
    .ivu-modal-header,
    .ivu-modal-footer {
        border: none !important;
    }
}
</style>
